import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
} from "react";
import { useContractKit } from "@celo-tools/use-contractkit";
import { Box, HStack, Text, Image, Button, Badge, Stack } from "@chakra-ui/react";
import Layout from "../components/layout";
import { buyToken, fetchListings } from "../lib/Market";
import { tokenURI } from "../lib/NFT";
import { get } from "axios";
import { BASE_GATEWAY_URI } from "../constants";
import { SimpleGrid } from '@chakra-ui/layout';

async function getMetadata(uri) {
  const resp = await get(`${BASE_GATEWAY_URI}${uri.replace("ipfs://", "")}`);
  return resp.data;
}

function Listings() {
  const { address, kit, performActions } = useContractKit();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTokens = useCallback(
    async (nftListings) => {
      if (!kit.web3) return;
      let listingsCopy = [...nftListings];
      for (let i = 0; i < listingsCopy.length; i++) {
        listingsCopy[i] = {
          ...listingsCopy[i],
          token: await getMetadata(
            await tokenURI(listingsCopy[i].tokenId, kit)
          ),
        };
      }
      return listingsCopy;
    },
    [kit, kit.web3]
  );
  useLayoutEffect(() => {
    if (!kit.web3) return;
    setLoading(true);
    fetchListings(kit).then((nftListings) => {
      if (!nftListings) return;
      console.log(nftListings);

      loadTokens(nftListings.filter((l) => l.onSale)).then(
        (listingsWithTokens) => {
          setListings(listingsWithTokens);
          setLoading(false);
        }
      );
    });
  }, [kit, kit.web3]);

  // useEffect(() => {
  //   if (listings.length == 0) return;
  // loadTokens().then((listingsWithTokens) => {
  //   setListings(listingsWithTokens);
  //   setLoading(false);
  //   });
  // }, [kit, kit.web3, listings]);

  return (
    <Layout>
      {listings.length > 0 ? (
        <Box>
          {listings.map((l) => (
            <Stack
              mt={8}
              borderWidth={2}
              bg="gray.800"
              borderColor="gray.600"
              borderRadius="md"
              overflow="hidden"
              alignItems="center"
              boxShadow="lg"
              direction={{base:'column', sm:'row'}}
              textAlign={{base:'center', sm:'left'}}
            >
              <Image
                src={`${BASE_GATEWAY_URI}${l.token.image.replace(
                  "ipfs://",
                  ""
                )}`}
                boxSize="180px"
              />
              <Stack
                w={"full"}
                justifyContent="space-between"
                alignItems={{base:"center", md:"start", lg:"start"}}
                p='4'
                direction={{base:'column', md:'row'}}
                
              >
                <Box>
                  <Text fontSize="lg" fontWeight="bold">
                    {l.token.title}
                  </Text>
                  <Text color="gray.300">{l.token.description}</Text>
                  <Badge mt={4} fontSize="md" bg="blue.100" p={2}>
                    {kit.web3.utils.fromWei(l.price, "ether")} $CELO
                  </Badge>
                </Box>
                <Button
                  ml="8"
                  flexShrink="0"
                  colorScheme="blue"
                  px={10}
                  onClick={() =>
                    buyToken(performActions, l.listingId, address, l.price)
                  }
                >
                  Buy
                </Button>
              </Stack>
            </Stack>
          ))}
        </Box>
      ) : (
        loading && "Loading..."
      )}
    </Layout>
  );
}

export default Listings;
